const testimonials = {
  wilson: {
    author: '- Jex H. Wilson, PGA Master Professional',
    blockquote:
      '“I received my ADM-Golf Certification just a few days ago. I am really excited about integrating Stages 2-3-4 into my OFGC PGA JL Program. This new approach is a game changer and I am excited to be on the ground floor.”'
  },
  milton: {
    author:
      '- Cameron Milton, Head Golf Professional at Polson (Montana) Bay Golf Course, 2018 PGA Youth Player Development Award Winner.',
    blockquote:
      '“ADM does a great job of reinforcing what a lot of us have already been doing, but brings it to the forefront for all coaches. I have been through far too many PGA educations to count and this one was by FAR the best from a content, production value, assessment etc. Head and shoulder above anything else.”'
  },
  jacobs: {
    author: '- Brian Jacobs, PGA',
    blockquote:
      '“I just wanted to reach out and thank you and your team at PGA.Coach. I received a lead during the PGA Championship from PGA.Coach. I followed up immediately and today I was able to meet with the student. I never would have had that lead without PGA.Coach and just wanted you, again, to know how grateful I am.”'
  }
}

export default testimonials
